import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import ReportDownloadModal from "../../common/ReportDownloadModal";
import { showToast } from "../../../utils";
import PageLoadingWithTable from "../../common/PageLoadingWithTable";

class ReportDownloadRedirect extends Component {
  state = {
    isModalOpen: false,
    s3Url: null,
    isChecking: true,
  };

  componentDidMount() {
    const { location, user } = this.props;
    const params = queryString.parse(location.search);
    const { s3Url } = params;

    // Check if user is authenticated
    if (!user || !user.loggedIn) {
      // Redirect to login with return URL
      showToast("Please log in to download the report.", false, 3000);
      const returnUrl = encodeURIComponent(location.pathname + location.search);
      this.props.history.push(`/login?returnUrl=${returnUrl}`);
      return;
    }

    // Validate S3 URL parameter
    if (!s3Url) {
      showToast("Invalid download link. Missing report URL.", false, 5000);
      this.props.history.push("/reports");
      return;
    }

    // User is authenticated and URL is valid, show modal
    this.setState({
      isModalOpen: true,
      s3Url: s3Url,
      isChecking: false,
    });
  }

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
    // Redirect to reports page after closing modal
    this.props.history.push("/reports");
  };

  render() {
    const { isModalOpen, s3Url, isChecking } = this.state;

    if (isChecking) {
      return <PageLoadingWithTable />;
    }

    return (
      <div>
        {isModalOpen && s3Url && (
          <ReportDownloadModal isOpen={isModalOpen} s3Url={s3Url} onClose={this.handleCloseModal} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userData.user,
});

export default withRouter(connect(mapStateToProps)(ReportDownloadRedirect));
